export default "__VITE_ASSET__e_F0_ub8__"